let currentScrollTop;
const lockBody = () => {
    currentScrollTop = window.pageYOffset;
    document.body.classList.add('locked');
    document.body.style.top = `-${currentScrollTop}px`;
};
const unlockBody = () => {
    document.body.classList.remove('locked');
    document.body.style.top = '';
    requestAnimationFrame(() => {
        window.scrollTo(0, currentScrollTop);
    });
};
export { lockBody, unlockBody };
